import { Component, OnInit } from '@angular/core';
import { PointofsaleService } from 'src/app/services/api/pointofsale/pointofsale.service';
import { ActivatedRoute } from '@angular/router';
import { ToolsService } from '../../../services/tools/tools.service';
import { Angulartics2GoogleAnalytics } from 'angulartics2';
import { TranslateService } from '@ngx-translate/core';
import { CssService } from "../../../services/css-service";
import { PanierService } from "../../../services/manage/panier/panier.service";
import { PointOfSaleSummary, ApiResponse } from 'src/app/services/api/fulle/fulle-pointOfSale/fulle-pointOfSale.service.interface';
import { FullePointOfSaleService } from 'src/app/services/api/fulle/fulle-pointOfSale/fulle-pointOfSale.service';

@Component({
  selector: 'app-fulle-pointofsale',
  templateUrl: './fulle-pointofsale.component.html',
  styleUrls: ['./fulle-pointofsale.component.css'],
})

export class FullePointofsaleComponent implements OnInit {
  pointsOfSale: PointOfSaleSummary[] = [];
  // pointsOfSale: any = null;
  // Banner par default
  banner_by_default = "assets/img/banners/restaurant.jpg";
  logo_by_default = "assets/img/logo/logo-fulle-xs.png";

  //Loader
  loader = true;

  constructor(
    private pointofsaleService: PointofsaleService,
    private tools: ToolsService,
    private route: ActivatedRoute,
    private angulartics2GoogleAnalytics: Angulartics2GoogleAnalytics,
    private fullePointOfSaleService: FullePointOfSaleService,
    public cssService: CssService,
    public translate: TranslateService,
  ) {

    // Tracing analytics
    this.angulartics2GoogleAnalytics.pageTrack("pointofsale");
  }

  async ngOnInit(): Promise<void> {
    // Suppression des local storage.
    this.removeStorageData();
    // Gestion du param URL pour charger la liste des points de vente
    this.route.params.subscribe();
    // Récupération des points de vente
    try {
      const PosId = this.tools.getStor("id_merchant")
      /// NOUVELLE ROUTE SLIM
      this.pointsOfSale = await this.fullePointOfSaleService.getPointOfSaleSummary(PosId, '', 'timetables');
      for(let pos in this.pointsOfSale){
        this.pointsOfSale[pos].url_encode = this.urlEncode(this.pointsOfSale[pos].denomination);
        this.pointsOfSale[pos].idWebshop = this.pointsOfSale[pos].idWebshop;
      }
      // this.pointsOfSale.url_encode = this.urlEncode(this.pointsOfSale.name);
      // console.log("fulle-pointofsale.component - ngOnInit - this.pointsOfSale : ", this.pointsOfSale);
      /// ANCIENNE ROUTE API ANTHO
      //  this.pointofsaleService.getAll().subscribe(points => {
      // this.pointsOfSale = points;
      // this.pointsOfSale.closings = this.pointsOfSale.closing // Pour la suite
      // console.log("this.pointsOfSale : ", this.pointsOfSale);
      // });
      /////////
    } catch (err) {
      console.error("fulle-pointofsale.component - ngOnInit - err =", err);
    }
    // Fin du load de la page.
    this.loader = false;
  }

  // Fonction de parse pour transcrire le nom du point de vente ou de l'user pour des url.
  // Correspond a un enrichissement de l'ancienne API.
  // TODO a voir si on garde.
  urlEncode(input: string): string {
    if (!input) return '';

    const unwantedMap: Record<string, string> = {
      'Š': 'S', 'š': 's',
      'Ž': 'Z', 'ž': 'z',
      'À': 'A', 'Á': 'A', 'Â': 'A', 'Ã': 'A', 'Ä': 'A', 'Å': 'A',
      'Æ': 'A',
      'Ç': 'C',
      'È': 'E', 'É': 'E', 'Ê': 'E', 'Ë': 'E',
      'Ì': 'I', 'Í': 'I', 'Î': 'I', 'Ï': 'I',
      'Ñ': 'N',
      'Ò': 'O', 'Ó': 'O', 'Ô': 'O', 'Õ': 'O', 'Ö': 'O', 'Ø': 'O',
      'Ù': 'U', 'Ú': 'U', 'Û': 'U', 'Ü': 'U',
      'Ý': 'Y',
      'Þ': 'B',
      'ß': 'Ss',
      'à': 'a', 'á': 'a', 'â': 'a', 'ã': 'a', 'ä': 'a', 'å': 'a',
      'æ': 'a',
      'ç': 'c',
      'è': 'e', 'é': 'e', 'ê': 'e', 'ë': 'e',
      'ì': 'i', 'í': 'i', 'î': 'i', 'ï': 'i',
      'ð': 'o',
      'ñ': 'n',
      'ò': 'o', 'ó': 'o', 'ô': 'o', 'õ': 'o', 'ö': 'o', 'ø': 'o',
      'ù': 'u', 'ú': 'u', 'û': 'u',
      'ý': 'y',
      'þ': 'b',
      'ÿ': 'y',
    };

    // équivalent de strtr()
    let s = input.replace(/./g, (c) => unwantedMap[c] ?? c);

    // équivalent des str_replace PHP
    s = s.replace(/ /g, '-');
    s = s.replace(/'/g, '-');
    s = s.replace(/\//g, '');

    // strtolower + urlencode
    return encodeURIComponent(s.toLowerCase());
  }

  removeStorageData() {
    // Suppression des local storage de commande.
    this.tools.removeStor("order_id");
    // Suppression des local storage de paiement.
    this.tools.removeStor("ClientKeyPayIntentOrder");
    // Suppression du panier en cours.
    this.tools.removeStor(PanierService.TAG_STORAGE);
  }

  // Selection d'un point de vente à l'écran
  selectPOS(point: any) {
    // console.log("selectPOS(point:", point);
    this.pointofsaleService.setPoint(point, false);
    // Redirection vers la page commande produit
    this.tools.goProductPage();
  }

  pointVisible() {
    let result = false;
    if (this.pointsOfSale)
      result = true;
    return result;
  }

  // Ouverture itineraire MAPS
  goToGmap(coord: string[]) {
    window.open("https://www.google.com/maps/?q=" + coord[0] + "," + coord[1]);
  }
}
